export const selectLocales = state => state.locales;
